import React from "react";
import "./Certificates.css";

const Certificates = ({ sectionTitle, certificates = [] }) => (
  <section className="certificates-section">
    <h3 className="section-header">
      <i className="fas fa-certificate"></i>
      {sectionTitle || "Certificates"}
    </h3>
    <div className="certificates-list">
      {certificates.map((cert, index) => (
        <div key={index} className="certificate-item">
          <h4 className="certificate-title">
            {cert.link ? (
              <a
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {cert.title}
              </a>
            ) : (
              cert.title
            )}
          </h4>
          <h5 className="certificate-issuer">{cert.issuer}</h5>
          <span className="duration highlight">{cert.date}</span>
          {cert.text && (
            <p className="certificate-description">{cert.text}</p>
          )}
        </div>
      ))}
    </div>
  </section>
);

export default Certificates;
